import Event from '../Event';

export default class ApplicationInitialized extends Event {
    public static type = 'ApplicationInitialized';

    constructor() {
        super(ApplicationInitialized.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/ApplicationInitialized.ts